module.exports = __webpack_public_path__ + "static/3_3_spam-or-ham_BG-018dda1c4678920891e3edd673544360.svg";